import type { AgentsClientInterface } from './agentsClient.types';
import BaseClient from '../BaseClient';

export default class CorporateAgentsClient extends BaseClient implements AgentsClientInterface {
    constructor(private teamId: number) {
        super();
    }

    getAgents() {
        const url = `/api/v3/teams/${this.teamId}/get-agents`;
        return this.makeCoreApiRequest(url);
    }
}
